import { createSelector, type MemoizedSelector } from '@ngrx/store';
import { QualificationsRecord } from '@ps/survey-utils';

import { surveyCreationFeature } from '../survey-creation.feature';

const { selectReference } = surveyCreationFeature;

export const selectQualificationsRecord = createSelector(
  selectReference,
  ({ qualificationsRecord }) => qualificationsRecord,
);

export const selectQuestionCategories = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.data,
);

export const selectQuestionCategoriesCachedAt = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.cachedAt,
);

export const selectIsQuestionCategoriesLoading = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.loading,
);

export const selectQuestionsRecord = createSelector(
  selectReference,
  ({ questionsRecord }) => questionsRecord,
);

export const selectQuestionsLoadingKey = createSelector(
  selectReference,
  ({ questionsLoadingKey }) => questionsLoadingKey,
);

export const selectLocationConditionsRecord = createSelector(
  selectReference,
  ({ locationConditionsRecord }) => locationConditionsRecord,
);

export const selectLocationConditionsLoadingKey = createSelector(
  selectReference,
  ({ locationConditionsLoadingKey }) => locationConditionsLoadingKey,
);

// Unwrapped straight from the cache — every locale's catalog, keyed the same way
// resolveQualifications resolves one (see mapSurveyLocalization).
export const selectQualificationsCatalogRecord = createSelector(
  selectQualificationsRecord,
  (qualificationsRecord): QualificationsRecord =>
    Object.fromEntries(
      Object.entries(qualificationsRecord).map(([key, entry]) => [
        key,
        entry.data,
      ]),
    ),
);

// Narrows the catalog record to the given locale keys (mapSurveyLocalization format).
export const selectQualificationsRecordForLocales = (
  locales: ReadonlySet<string>,
): MemoizedSelector<object, QualificationsRecord> =>
  createSelector(
    selectQualificationsCatalogRecord,
    (catalogRecord): QualificationsRecord =>
      Object.fromEntries(
        Object.entries(catalogRecord).filter(([key]) => locales.has(key)),
      ),
  );
